import { Suspense, lazy } from "react";
import type { IntlConfig } from "react-intl";
import { IntlProvider } from "react-intl";

import { DEFAULT_RICH_TEXT_ELEMENTS } from "./rich-text";

const DEFAULT_LANG = "en";

const locale = (window.navigator.language || DEFAULT_LANG).split("-")[0];

const LazyLangProvider = lazy(() =>
  import(`../locales/${locale}.json`)
    // if the chosen locale cannot be found, use the default
    .catch(() => import(`../locales/${DEFAULT_LANG}.json`))
    .then(({ default: messages }) => ({
      default: (props: any) => (
        <IntlProvider
          {...props}
          defaultRichTextElements={DEFAULT_RICH_TEXT_ELEMENTS}
          locale={locale}
          messages={messages}
        />
      ),
    })),
);

export interface LangProps extends Pick<IntlConfig, "timeZone"> {
  children: React.ReactNode;
}

export function LangProvider({ children, timeZone }: LangProps) {
  return (
    <Suspense fallback={null}>
      <LazyLangProvider timeZone={timeZone}>{children}</LazyLangProvider>
    </Suspense>
  );
}
